// 获取全量用户信息
const _getUserInfo = () => {
  if (_getUserInfo._cacheU) {
    return _getUserInfo._cacheU
  }
  try {
    let res = window.getNewUserInfo && window.getNewUserInfo()
    // 避免外部修改
    Object.freeze && Object.freeze(res)
    if (res && res.UserId) {
      _getUserInfo._cacheU = res
      return res
    } else {
      console.error('找不到window上的getNewUserInfo')
      return null
    }
  } catch (error) {
    console.log(error)
  }
}

/**
 * 生成带用户信息的自定义 key
 * @param {string} key - 业务 key
 * @param {object} [options] - 可选参数
 * @param {Array<string>} [options.fields] - 需要拼接的 userInfo 返回的字段 默认是 ['TMSCode', 'UserId']
 * @returns {string}
 */
function handleCustomKey(key, options = {}) {
  const userInfo = _getUserInfo() || {};
  // 先不启用options 配置 后续若使用其他options.fields 再启用
  // const fields = options && Array.isArray(options.fields) && options.fields.length > 0 ? options.fields : ['TMSCode', 'UserId'];
  // const arr = fields.map(f => userInfo[f] || '').filter(Boolean);
  // arr.push(key);
  // return arr.join('_');

  // 目前仅使用TMSCode + '_' + UserId + '_' + key 若启用options时这段代码注释，上段代码放开即可
  options.fields = ['TMSCode', 'UserId'];
  return userInfo.TMSCode + '_' + userInfo.UserId + '_' + key;
}
/**
 * 生成自定义key的localStorage
 * @param {string} key - 业务key
 * @param {string} val - 缓存值
 * @param {object} [options] - 可选参数
 * @param {Array<string>} [options.fields] - 需要拼接的 userInfo 字段 默认是 ['TMSCode', 'UserId']
 */
function setUserLocalStorage(key, val, options) {
  const customKey = handleCustomKey(key, options);
  localStorage.setItem(customKey, val);
}
/**
 * 获取自定义key的localStorage
 * @param {string} key - 业务key
 * @param {object} [options] - 可选参数
 * @param {Array<string>} [options.fields] - 需要拼接的 userInfo 字段 默认是 ['TMSCode', 'UserId']
 */
function getUserLocalStorage(key, options) {
  const customKey = handleCustomKey(key, options);
  return localStorage.getItem(customKey);
}
/**
 * 删除自定义key的localStorage
 * @param {string} key - 业务key
 * @param {object} [options] - 可选参数
 * @param {Array<string>} [options.fields] - 需要拼接的 userInfo 字段 默认是 ['TMSCode', 'UserId']
 */
function removeUserLocalStorage(key, options) {
  const customKey = handleCustomKey(key, options);
  localStorage.removeItem(customKey);
}
/**
 * 生成自定义key的sessionStorage
 * @param {string} key - 业务key
 * @param {string} val - 缓存值
 * @param {object} [options] - 可选参数
 * @param {Array<string>} [options.fields] - 需要拼接的 userInfo 字段 默认是 ['TMSCode', 'UserId']
 */
function setUserSessionStorage(key, val, options) {
  const customKey = handleCustomKey(key, options);
  sessionStorage.setItem(customKey, val);
}
/**
 * 获取自定义key的sessionStorage
 * @param {string} key - 业务key
 * @param {object} [options] - 可选参数
 * @param {Array<string>} [options.fields] - 需要拼接的 userInfo 字段 默认是 ['TMSCode', 'UserId']
 */
function getUserSessionStorage(key, options) {
  const customKey = handleCustomKey(key, options);
  return sessionStorage.getItem(customKey);
}
/**
 * 删除自定义key的sessionStorage
 * @param {string} key - 业务key
 * @param {object} [options] - 可选参数
 * @param {Array<string>} [options.fields] - 需要拼接的 userInfo 字段 默认是 ['TMSCode', 'UserId']
 */
function removeUserSessionStorage(key, options) {
  const customKey = handleCustomKey(key, options);
  sessionStorage.removeItem(customKey);
}

/**
 * 获取头部导航栏高度
 */
function getTopNavHeight() {
  return top.$("#topmenu").height()
}

/**
 * 获取头部二级导航栏高度
 */
function getIframeTabHeight() {
  return top.$(".l-tab-links").height()
}

/**
 * 获取头部导航栏总高度
 */
function getTopNavAllHeight() {
  return getTopNavHeight() + getIframeTabHeight()
}


// 将之前的灰度方法也加入全局api
import { getAllGrayConfig, getAllUserGrayConfig } from '@/utils/getAllGrayConfig.js'
export default {
  getUserInfo: _getUserInfo,
  getAllGrayConfig,
  getAllUserGrayConfig,
  setUserLocalStorage,
  getUserLocalStorage,
  removeUserLocalStorage,
  setUserSessionStorage,
  getUserSessionStorage,
  removeUserSessionStorage,
  getTopNavHeight,
  getIframeTabHeight,
  getTopNavAllHeight
}
